const register = [
  {
    value: 'supplierId',
    sortable: false,
    align: ' d-none'
  },
  {
    value: 'supplierName',
    sortable: false,
    align: ' d-none'
  },
  {
    value: 'productCategoryId',
    sortable: false,
    align: ' d-none'
  },
  {
    text: 'product.product_product-number',
    value: 'productNumber',
    sortable: false,
    width: '9%',
    align: 'center'
  },
  {
    text: 'sale.sale_product-name-capacity',
    value: 'productInfoAndCapacity',
    sortable: false,
    width: '25%'
  },

  {
    text: 'sale.sale_stock',
    value: 'stock',
    sortable: false,
    width: '10%',
    align: 'center'
  },
  {
    text: 'stock-adjust.stock-adjust_adjust-quantity',
    value: 'count',
    sortable: false,
    width: '10%'
  }
]
const history = [
  {
    value: 'supplierId',
    sortable: false,
    align: ' d-none'
  },
  {
    value: 'supplierName',
    sortable: false,
    align: ' d-none'
  },
  {
    value: 'productCategoryId',
    sortable: false,
    align: ' d-none'
  },
  {
    text: 'order.order_invalid',
    value: 'invalid',
    sortable: false,
    width: '5%'
  },
  {
    text: 'product.product_product-number',
    value: 'productNumber',
    sortable: false,
    width: '9%'
  },
  {
    text: '商品名・容量',
    value: 'productInfoAndCapacity',
    sortable: false,
    width: '25%'
  },
  {
    text: `消費\n税率`,
    value: 'taxId',
    sortable: false,
    width: '5%',
    align: 'center'
  },
  {
    text: 'product.product_purchase-price',
    value: 'purchasePrice',
    sortable: false,
    width: '8%',
    align: 'center',
    unit: '%',
    currencyIdName: 'purchasePriceCurrencyId'
  },
  {
    text: '仕入価格\n（unitName）',
    value: 'purchasePriceAndUnitName',
    sortable: false,
    width: '8%',
    align: 'center'
  },
  {
    text: '在庫\n（移動中在庫）',
    value: 'stock',
    sortable: false,
    width: '10%',
    align: 'center'
  },
  {
    text: 'sale.sale_number-of-sales',
    value: 'count',
    sortable: false,
    width: '10%'
  },
  {
    text: '販売単価\n（unitName）',
    value: 'priceAndUnitName',
    sortable: false,
    width: '10%'
  },
  {
    text: 'sale.sale_price',
    value: 'amount',
    sortable: false,
    width: '10%',
    align: 'center',
    unit: '円'
  },
  {
    text: 'sale.sale_exporter',
    value: 'exportSubjectFlg',
    sortable: false,
    width: '5%',
    align: 'center'
  }
]

export default { register, history }
